import { OverlayContainer } from '@angular/cdk/overlay';
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MediaChange, MediaObserver } from "@angular/flex-layout";
import { MatSidenav } from "@angular/material/sidenav";
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthenticationService, LoginUser } from '@mango/authentication';
import { AuthorizationScheme, AuthorizationSchemeService, DialogsService, Filter, FilterMethod, FilterProperty, GlobalService } from '@mango/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Alert } from 'src/app/alert/alert';
import { AlertService } from 'src/app/alert/alert.service';
import { User } from 'src/app/user/user';
import { UserCollectionComponent } from 'src/app/user/user-collection.component';
import { environment } from 'src/environments/environment';
import { SendMailPopupComponent } from '../sendmail-popup/sendmail-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { RelatieCollectionComponent } from 'src/app/cij/relatie/relatie/relatie-collection.component';
import { Relatie } from 'src/app/core/dto/relatie';

@Component({
    selector: 'base-layout',
    templateUrl: './base-layout.component.html',
    styleUrls: ['./base-layout.component.css']
})
export class BaseLayoutComponent implements OnInit, OnDestroy {

    protected onDestroy$ = new Subject<void>();

    @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
    @HostBinding('class') componentCssClass;
    myScheme: AuthorizationScheme;
    watcher: Subscription;
    mode: 'side' | 'over' = 'side';
    opened: boolean = true;
    applicationName: string;

    amountOfNotifications: number;
    
    constructor(private media: MediaObserver,
        public global: GlobalService,
        private authService: AuthorizationSchemeService,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private overlayContainer: OverlayContainer,
        private cd: ChangeDetectorRef,
        private snackbar: MatSnackBar,
        private router: Router,
        private dialogService: DialogsService, 
        private matDialog: MatDialog
    ) {
        this.watcher = media.media$.subscribe((change: MediaChange) => {
            if (change.mqAlias == 'xs' || change.mqAlias == 'sm') {
                this.mode = 'over'
                this.opened = false;
            } else {
                this.mode = 'side';
                this.opened = true;
            }
        });
    }

    ngOnInit() {
        this.myScheme = this.authService.getMyScheme();

        if (!this.myScheme) {
            this.router.navigateByUrl('/login');
        }

        if (this.myScheme.canRead('CIJBorculo.Logic.Alert')) {
                        
            this.getAmountOfNotifications();
            this.alertService.hubSubject.pipe(takeUntil(this.onDestroy$)).subscribe(data => {
                this.getAmountOfNotifications();
            });
        }
        
        var theme = localStorage.getItem('theme') || 'light-theme';
        this.setTheme(theme);
        this.eeActive = localStorage.getItem('easter-egg') ? true : false;

        this.applicationName = environment.ApplicationName;
    }

    ngOnDestroy(): void {
        if (this.watcher) {
            this.watcher.unsubscribe();
        }
    }

    closeSideNav() {
        if (this.media.isActive('lt-md')) {
            this.sidenav.close();
        }
    }

    setTheme(theme: string) {
        const currentTheme = localStorage.getItem('theme') || 'light-theme';
        const overlayClassList = this.overlayContainer.getContainerElement().classList;
        if (overlayClassList.contains(currentTheme)) {
            overlayClassList.remove(currentTheme);
        }
        overlayClassList.add(theme);
        this.componentCssClass = theme;
        localStorage.setItem('theme', theme);
                
        if (theme != 'easter-egg-theme')
        {
            this.eeActive = false;
            localStorage.setItem('easter-egg', '0');
        }

    }

    stopPropagation(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        return false;
    }

    canRead(type: string) {
        return this.myScheme.canRead(type);
    }

    canCreate(type: string) {
        return this.myScheme.canCreate(type);
    }

    canDo(type: string) {
        return this.myScheme.canDo(type);
    }
    
    canNavigate(type: string) {
        return this.myScheme.canShowInNavigation(type);
    }
    
    get currentUser(): LoginUser {
        return this.authenticationService.currentUser;
    }

    getAmountOfNotifications() {
       
        this.alertService.get({ properties:[x => x.count(x.id)], filter: new Filter<Alert>(fb => [fb.equal(x => x.valid, true)])} ).subscribe(x => {
            if (x.data.length > 0) {
                this.amountOfNotifications = x.data[0].count_Id;
             }
        });
    }

    canSeeBeheer() {
        return (
            (this.canCreate('CIJBorculo.Logic.Alert') && this.canNavigate('CIJBorculo.Logic.Alert'))|| 
            (this.canCreate('CIJBorculo.Logic.Bedrijf') && this.canNavigate('CIJBorculo.Logic.Bedrijf')) || 
            (this.canCreate('CIJBorculo.Logic.VertaalTabel') && this.canNavigate('CIJBorculo.Logic.VertaalTabel')) ||
            (this.canCreate('CIJBorculo.Logic.VerzendTarieven') && this.canNavigate('CIJBorculo.Logic.VerzendTarieven')) ||
            (this.canCreate('CIJBorculo.Logic.FactuurType') && this.canNavigate('CIJBorculo.Logic.FactuurType')) || 
            (this.canCreate('CIJBorculo.Logic.Btw') && this.canNavigate('CIJBorculo.Logic.Btw')) || 
            (this.canCreate('CIJBorculo.Logic.Status') && this.canNavigate('CIJBorculo.Logic.Status')) || 
            (this.canCreate('CIJBorculo.Logic.Merk') && this.canNavigate('CIJBorculo.Logic.Merk')) || 
            (this.canCreate('CIJBorculo.Logic.Rubriek') && this.canNavigate('CIJBorculo.Logic.Rubriek')) || 
            (this.canCreate('CIJBorculo.Logic.Soort') && this.canNavigate('CIJBorculo.Logic.Soort')) || 
            (this.canCreate('CIJBorculo.Logic.Tekst') && this.canNavigate('CIJBorculo.Logic.Tekst')) || 
            (this.canCreate('CIJBorculo.Logic.Voorblad') && this.canNavigate('CIJBorculo.Logic.Voorblad')) ||
            (this.canCreate('CIJBorculo.Logic.Volgblad') && this.canNavigate('CIJBorculo.Logic.Volgblad')) ||
            (this.canCreate('CIJBorculo.Logic.Afdeling') && this.canNavigate('CIJBorculo.Logic.Afdeling')) ||
            (this.canCreate('CIJBorculo.Logic.Projectgroep') && this.canNavigate('CIJBorculo.Logic.Projectgroep')) ||
            (this.canCreate('CIJBorculo.Logic.PostType') && this.canNavigate('CIJBorculo.Logic.PostType')) ||
            (this.canCreate('CIJBorculo.Logic.Land') && this.canNavigate('CIJBorculo.Logic.Land')) ||
            (this.canCreate('CIJBorculo.Logic.Taal') && this.canNavigate('CIJBorculo.Logic.Taal')) ||
            (this.canCreate('CIJBorculo.Logic.Artikelgroep') && this.canNavigate('CIJBorculo.Logic.Artikelgroep'))
        );            
    }

    canSeeAlgemeen() {
        return (
            (this.canCreate('CIJBorculo.Logic.Bedrijf') && this.canNavigate('CIJBorculo.Logic.Bedrijf')) || 
            (this.canCreate('CIJBorculo.Logic.VertaalTabel') && this.canNavigate('CIJBorculo.Logic.VertaalTabel') )
        );            
    }

    canSeeFinancieel() {
        return (
            (this.canCreate('CIJBorculo.Logic.VerzendTarieven') && this.canNavigate('CIJBorculo.Logic.VerzendTarieven')) ||
            (this.canCreate('CIJBorculo.Logic.FactuurType') && this.canNavigate('CIJBorculo.Logic.FactuurType')) || 
            (this.canCreate('CIJBorculo.Logic.Btw') && this.canNavigate('CIJBorculo.Logic.Btw')) 
        );            
    }

    canSeeInstrumenten() {
        return (
            (this.canCreate('CIJBorculo.Logic.Merk') && this.canNavigate('CIJBorculo.Logic.Merk')) || 
            (this.canCreate('CIJBorculo.Logic.Rubriek') && this.canNavigate('CIJBorculo.Logic.Rubriek')) || 
            (this.canCreate('CIJBorculo.Logic.Soort') && this.canNavigate('CIJBorculo.Logic.Soort')) || 
            (this.canCreate('CIJBorculo.Logic.Tekst') && this.canNavigate('CIJBorculo.Logic.Tekst')) || 
            (this.canCreate('CIJBorculo.Logic.Voorblad') && this.canNavigate('CIJBorculo.Logic.Voorblad')) ||
            (this.canCreate('CIJBorculo.Logic.Volgblad') && this.canNavigate('CIJBorculo.Logic.Volgblad'))
        );            
    }

    canSeeLogistiek() {
        return (
            (this.canCreate('CIJBorculo.Logic.Afdeling') && this.canNavigate('CIJBorculo.Logic.Afdeling')) ||
            (this.canCreate('CIJBorculo.Logic.Projectgroep') && this.canNavigate('CIJBorculo.Logic.Projectgroep')) ||
            (this.canCreate('CIJBorculo.Logic.PostType') && this.canNavigate('CIJBorculo.Logic.PostType')) ||
            (this.canCreate('CIJBorculo.Logic.Land') && this.canNavigate('CIJBorculo.Logic.Land')) ||
            (this.canCreate('CIJBorculo.Logic.Taal') && this.canNavigate('CIJBorculo.Logic.Taal')) ||
            (this.canCreate('CIJBorculo.Logic.Status') && this.canNavigate('CIJBorculo.Logic.Status')) ||
            (this.canCreate('CIJBorculo.Logic.Artikelgroep') && this.canNavigate('CIJBorculo.Logic.Artikelgroep'))
        );            
    }

    // An inconspicuous easter-egg
    eeActive = false;
    private eeClickCount = 0;
    onEasterEggClicked(event: any) {
        event.preventDefault(); event.stopPropagation();
        this.eeClickCount++;
        if (this.eeClickCount == 7) { this.snackbar.open('Deze knop doet niets...', 'OK', { duration: 3500 }); }
        if (this.eeClickCount == 14) { this.snackbar.open(`Toch doorklikken?`, 'OK', { duration: 3500 }); }
        if (this.eeClickCount == 21) { this.snackbar.open('Oké, een nieuw (tijdelijk) theme...', 'OK', { duration: 3500 }); }
        if (this.eeClickCount == 28) { this.eeActive = true; localStorage.setItem('easter-egg', '1'); }
    }
    onThemesClosed(event: any) { this.eeClickCount = 0; }

    startMailingUsers(){

        this.dialogService.multiSelect({
            title: "Selecteer Users",
            collectionComponent: UserCollectionComponent,
            isSelectable: () => true,
            preselect:  [],
        }).then((result) => { 
            
            let users: User[] = [];
            let relaties: Relatie[] = [];

            if (result != null) {
                result.selected.forEach((user: User) => {
                    users.push(user);
                });
                
                const DialogRef = this.matDialog.open(SendMailPopupComponent, {
                    width: '1000px',
                    disableClose: true,            
                    data: {
                      users: users,
                      relaties: relaties
                    }      
                });
            }
           
        });

    }

    startMailingRelaties(){

        var myFilter = new Filter<Relatie>();
        myFilter.add(new FilterProperty('eMail', FilterMethod.NotEqual, null),true);
        myFilter.add(new FilterProperty('eMail', FilterMethod.NotEqual, ""),true);
        myFilter.add(new FilterProperty('isRelatie', FilterMethod.Equal, true),false);

        this.dialogService.multiSelect({
            title: "Selecteer Relaties",
            collectionComponent: RelatieCollectionComponent,
            filter: myFilter,
            isSelectable: () => true,
            preselect:  [],
        }).then((result) => { 
            
            let relaties: Relatie[] = [];
            let users: User[] = [];

            if (result != null) {
                result.selected.forEach((relatie: Relatie) => {
                    relaties.push(relatie);
                });
                
                const DialogRef = this.matDialog.open(SendMailPopupComponent, {
                    width: '1000px',
                    disableClose: true,            
                    data: {
                        users: users,
                        relaties: relaties
                    }      
                });
            }
           
        });

    }
}


